import { Modal, Typography } from '@automata/ui';
import { Box, Stack } from '@mui/material';

import { NewParameterSelector } from './NewParameterSelector';
import { ParametersList } from './ParametersList';
import { selectParameterDefinitions } from '../../../features/workflow/selectors';
import { useAppSelector } from '../../../hooks';

interface ParameterReferenceModalProps {
  onClose: () => void;
}

export const ParameterReferenceModal = ({
  onClose,
}: ParameterReferenceModalProps) => {
  const parameters = useAppSelector(selectParameterDefinitions);

  return (
    <Modal open maxWidth={true} title="Parameter reference" onClose={onClose}>
      <Stack minHeight={600}>
        {parameters.length === 0 ? (
          <Box margin="auto" textAlign="center">
            <Box maxWidth={420} paddingBottom={3}>
              <Typography variant="body1">
                Create parameter references that can be applied across your
                workflow and be overridden at runtime.
              </Typography>
            </Box>

            <NewParameterSelector showHint={false} />
          </Box>
        ) : (
          <Box paddingBottom={3}>
            <NewParameterSelector showHint={true} />
            <ParametersList />
          </Box>
        )}
      </Stack>
    </Modal>
  );
};
